export const sidebar_extension = {
  light: {
    sidenavbg: {
      color: "#1E6B4A",
    },
    sidenavpanelborder: {
      color: "#E2E8F033",
    },
    listpanelbtmborder: {
      color: "#E2E8F033",
    },
    sidenavhover: {
      color: "#134A33",
    },
    arrowcol: {
      color: "#fff",
    },
    arrowcoldark: {
      color: "#000",
    },
    sidenavleftactivecol: {
      color: "#134A33",
    },
  },
  dark: {
    sidenavbg: {
      color: "#1E6B4A",
    },
    sidenavpanelborder: {
      color: "#E2E8F033",
    },
    sidenavhover: {
      color: "#134A33",
    },
    arrowcol: {
      color: "#fff",
    },
    arrowcoldark: {
      color: "#000",
    },
    sidenavleftactivecol: {
      color: "#134A33",
    },
    listpanelbtmborder: {
      color: "#E2E8F033",
    },
  },
};
